import React from 'react'
import {connect} from 'react-redux'
import styles from './signatures.scss'
import {reduxForm} from 'redux-form'
import nesProp from 'nested-property'
import underscore from 'underscore'
import {formatDate} from 'lib/helpers'
import i18n from 'lib/i18n'
import cs from 'classnames'
import {localUploadHandler} from 'state/actions'

const _ = i18n('office')

const validate = values => {
	const errors = {}
	if (underscore.isEmpty(values.nameField)) {
		errors.nameField = _('nameFieldIsRequired')
	}
	if (underscore.isEmpty(values.contentField)) {
		errors.contentField = _('contentFieldIsRequired')
	}
	return errors
}
@connect((state)=>({
    currentBrNr: state.app.brNr,
    broker: state.office.brokers[state.app.brNr],
    brokers: state.office.brokers,
}))
@reduxForm({
    form: "signature",
    fields: ["nameField","contentField","isDefaultField"],
    validate,
    destroyOnUnmount: true,
    touchOnBlur: true,
    touchOnChange: true,
})
export default class SignatureZoom extends React.Component {
    static propTypes = {
        fields: React.PropTypes.object.isRequired,
        signature: React.PropTypes.object,
        onRemoveSignature: React.PropTypes.func.isRequired,
        onUpdateSignature: React.PropTypes.func.isRequired,
        onCloseSignature: React.PropTypes.func.isRequired,
        onSetDefaultSignature: React.PropTypes.func.isRequired,
        onSaveSignature: React.PropTypes.func.isRequired,
        getNewSignatureTable: React.PropTypes.func.isRequired,
        signatureDefaultValues: React.PropTypes.func.isRequired,
        currentBrNr: React.PropTypes.string,
        replaceTransparentLogoToPlaceholder: React.PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props)
        this.state = {
            theContentEditor: null
        }
    }

    /**
     * This will set the form value content in store
     */
    updateFormValue(value, field) {
        const {dispatch} = this.props
        return dispatch({
            type: "redux-form/CHANGE",
            field: field.name,
            value: value && value.value || '',
            touch: value && value.touched || field.touched,
            form: "signature"
        })
    }

    /**
     * This function will give an init value for body editor
     */
    setInitialSignatureContent() {
        const {signature, fields, replaceTransparentLogoToPlaceholder, getNewSignatureTable,
            currentBrNr} = this.props

        if (!signature || !signature._id) {
            getNewSignatureTable(currentBrNr).then((result) => {
                result = replaceTransparentLogoToPlaceholder(result)
                this.updateFormValue({value: result}, fields.contentField)
            })
        } else {
            let content = signature && signature.content || ''

            if (content) {
                content = replaceTransparentLogoToPlaceholder(content)
            }

            this.updateFormValue({value: content}, fields.contentField)
        }
    }

    /**
     * Handle mobile touch
     * @param {*} field
     */
    touch(field) {
		field.onBlur()
    }

    /**
     * This will initialize the module after mounting.
     */
    componentDidMount () {
        const {signature, fields} = this.props

        this.setInitialSignatureContent()
        this.setupTinyMce()
        this.updateFormValue({value: nesProp.get(signature, "name") || ""}, fields.nameField)
        this.updateFormValue({value: Boolean(nesProp.get(signature, "isDefault"))}, fields.isDefaultField)
    }

    /**
     * Triggered before update the module
     */
    componentWillUpdate(nextProps, nextState) {
        // we have to initialize the content of signature content here separately because it is not a regular form field
        if( nextProps.fields.contentField.value !== this.props.fields.contentField.value ) {
            this.updateContentEditor(nextProps.fields.contentField.value)
        }

				if (nextProps.signature.name !== this.props.signature.name) {
						this.updateFormValue({value: nextProps.signature.name}, this.props.fields.nameField)
				}
    }

    /**
	 * We have to reset the references because the editors will reinitialize on mount.
	 */
	componentWillUnmount () {
        window.tinymce.execCommand('mceFocus', true, "tinymce" )
        window.tinymce.execCommand('mceRemoveEditor',true, "tinymce")
        window.tinymce.execCommand('mceRemoveControl',false, "tinymce")
    }

    /**
     * This function provide the apicall result and callback call for the tiny mce editor,
     * trough a redux action
     * @param {*} blobInfo
     * @param {function} success
     * @param {function} failure
     */
    imagesUploadHandler(blobInfo, success, failure) {
        const {dispatch} = this.props
        return dispatch(localUploadHandler(blobInfo, success, failure))
    }

    /**
     * The editor initialization.
     */
    setupTinyMce() {
        const {signature, fields, replaceTransparentLogoToPlaceholder} = this.props
        // window.tinymce.execCommand('mceAddEditor',true, "tinymce")
        window.tinymce.init({
            selector: '#tinymce',
            min_height: 365,
            menubar: false,
            mode : "readonly",
            //theme_url: window.location.protocol+'//'+(window.location.href.split("/")[2] + '/themes/modern/theme.js').replace("\/\/", "\/"),
            //skin_url:  window.location.protocol+'//'+(window.location.href.split("/")[2] + '/skins/lightgray/').replace("\/\/", "\/"),
            theme : "silver",
            statusbar: false,
            // toolbar: 'bold italic underline | undo redo | link | code', plugins: ['paste', 'link', 'autoresize'],
            toolbar1 : "bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | formatselect fontselect fontsizeselect",
            toolbar2 : "paste pastetext searchreplace | bullist numlist | outdent indent | undo redo | link unlink anchor image code",
            toolbar3 : "forecolor backcolor | table | hr removeformat visualchars | subscript superscript | charmap preview | fullscreen",
            // external_plugins: {
            //     'textcolor': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/textcolor/plugin.js').replace("\/\/", "\/"),
            //     'link': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/link/plugin.js').replace("\/\/", "\/"),
            //     'image': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/image/plugin.js').replace("\/\/", "\/"),
            //     'code': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/code/plugin.js').replace("\/\/", "\/"),
            //     'searchreplace': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/searchreplace/plugin.js').replace("\/\/", "\/"),
            //     'paste': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/paste/plugin.js').replace("\/\/", "\/"),
            //     'visualchars': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/visualchars/plugin.js').replace("\/\/", "\/"),
            //     'charmap': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/charmap/plugin.js').replace("\/\/", "\/"),
            //     'table': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/table/plugin.js').replace("\/\/", "\/"),
            //     'fullscreen': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/fullscreen/plugin.js').replace("\/\/", "\/"),
            //     'preview': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/preview/plugin.js').replace("\/\/", "\/"),
            // },
            plugins : ["textcolor link image code searchreplace paste visualchars charmap table fullscreen preview"],
            force_br_newlines : false,
            force_p_newlines : false,
            forced_root_block : '',
            relative_urls: false,
            convert_urls: true,
            remove_script_host: false,
            allow_script_urls: true,

            valid_elements : "*[*]",
            extended_valid_elements : "tr[style]",
            inline_styles : true,
            verify_html : false,
            visual: false, // for table borders off
            //remove_script_host: false,
            images_upload_url: 'uploads/localUploads/',
            images_upload_handler: (blobInfo, success, failure) => (this.imagesUploadHandler(blobInfo, success, failure)),
            setup: (editor) => {
                this.setState({theContentEditor: editor})
                /* editor.on('NodeChange', function(e) {
                    actualCaretPositionBookmark = editor.selection.getBookmark(2, true)
                })
                editor.on('SetContent', function(e) {
                    editor.selection.moveToBookmark(actualCaretPositionBookmark)
                })
                editor.on('KeyPress', function(e) {
                    actualCaretPositionBookmark = editor.selection.getBookmark(2, true)
                }) */
                /* editor.on('change', (e)=>{
                    this.updateFormValue({value: editor.getContent(), touch: true}, {...fields.contentField, touch: true})
                }) */
                editor.on('blur', (e)=>{
                    this.updateFormValue({value: editor.getContent(), touch: true}, {...fields.contentField, touch: true})
                })
                editor.on('click', (e)=>{
                    this.updateFormValue({value: editor.getContent(), touch: true}, {...fields.contentField, touch: true})
                })
                editor.on('init', (e)=>{
                    this.updateContentEditor()
                })
                /* editor.on('change', (e)=>{
                    this.updateFormValue({value: editor.getContent(), touch: true}, {...fields.contentField, touch: true})
                }) */
            }
        })
    }

    /**
     * This function will initialize the body editor when you call it and replace the body value instantly
     * @param {String} newValue - new body html value for email
     */
    updateContentEditor(forceValue = null) {
        const {signature, replaceTransparentLogoToPlaceholder} = this.props
        const {theContentEditor} = this.state
        const contentField = nesProp.get(this.props, "fields.contentField")

        let newValue

        if (forceValue === null) {
            newValue = (contentField && contentField.value) || ''
        } else {
            newValue = forceValue
        }

        if (newValue) {
            newValue = replaceTransparentLogoToPlaceholder(newValue)
        }

        if(window.tinymce && theContentEditor) {
            if (newValue) {
                let body = String(newValue) || ''
                try {
                    theContentEditor.setContent(body, {format: 'raw'})
                } catch(exc) {
                    // error handling
                }
            } else {
                try {
                    theContentEditor.setContent('' , {format: 'raw'})
                } catch(exc) {
                    // error handling
                }
            }
        }
    }

    /**
     * This function will return TRUE if minimum one of the form fields contains errors, about the values.
     */
    hasErrors() {
        const fields = nesProp.get(this.props, "fields")
        let errors = false
        Object.keys(fields).forEach((indexVal) => {
            errors = errors || !underscore.isEmpty(fields[indexVal].error)
        })
        return Boolean(errors)
    }

    /**
     * This function can enable the saving of a new signature or update an old one,
     * verify the validity of values.
     */
    isDisabledTheSubmit() {
        const {fields: {nameField, contentField, isDefaultField}} = this.props
        return !underscore.isEmpty(validate({
            nameField: nameField && nameField.value || '',
            contentField: contentField && contentField.value || '',
            isDefaultField: isDefaultField && isDefaultField.value || false,
        }))
    }

    /**
     * This function enable the "make as default" button if the signature already saved. (Has _id)
     * @param {object} signature
     */
    isDisabledTheMakeDefault(signature) {
        return !signature._id
    }

    /**
     * This function return with a React element for render, what contains the signature body editor
     * filled with the signature content.
     */
    renderBodyEditor() {
        const {theContentEditor} = this.state
        const contentField = nesProp.get(this.props, "fields.contentField")

        if (window.tinymce && theContentEditor) {
            if (this.canEditOrCreateSignature()) {
                // theContentEditor.execCommand("mceToggleVisualAid")
                theContentEditor.setMode("design")
            } else {
                theContentEditor.setMode("readonly")
            }
        }

        return (
            <div className={styles.formGroup}>
                <label className={styles.formLabel} htmlFor="contentField">{_("signatureContent")}</label>
                <div className={styles.inputHolder}>
                    <div className={styles.formInput}>
                        <textarea id="tinymce" />
                    </div>
                    {contentField.touched && contentField.error && <div className={styles.errorMessage}>
                        {contentField.error}
                    </div>}
                </div>
            </div>
        )
    }

    /**
     * This function decide the right to create or edit a signature for broker.
     */
    canEditOrCreateSignature() {
        const {brokers, currentBrNr, signature} = this.props
        //let hisOwnSignature = signature && signature.brokerNumber && (signature.brokerNumber === currentBrNr) ? true : false
        // default the user can edit the signature if there are no brokernumber attached,
        // because we don't want to block forever a signature
        let can = true
        // werify if signature has brokernumber attached
        if (signature && signature.brokerNumber) {
            // get the signature owner broker right for editing his signature
            can = brokers && nesProp.get(brokers, signature.brokerNumber + ".main.modifySignature")
        }

        // REMOVE REMOVE REMOVE REMOVE REMOVE REMOVE +++
        // TODO remove this if. Only for testing
        /* if (currentBrNr == "90069") {
            can = true
        } */
        // REMOVE REMOVE REMOVE REMOVE REMOVE REMOVE ---

        // handle if a string is the boolean value
        can = (can === "false" ? false : (can === "true" ? true : !!can))
        return can
    }

    /**
     * This is the main rendering function of the react.
     */
	render() {
        // loading values for render
        const {onRemoveSignature, onUpdateSignature, onCloseSignature, onSetDefaultSignature, onSaveSignature,
            fields: {nameField, contentField, isDefaultField}, dispatch, signatureDefaultValues} = this.props
        let {signature, currentBrNr} = this.props

        // basic initialization in the form for a new signature if this is not an edit mode.
        if (underscore.isEmpty(signature)) {
            signature = signatureDefaultValues()
        }

        // decide the creat/update right of current broker for this signature.
        let canBrokerCreateOrUpdate = this.canEditOrCreateSignature()
		return (
			<div>
                <div className={styles.buttonsContainer}>
					<input
                        onClick={() => {

                            onCloseSignature()
                        }}
						type="button"
						className={`greyButton`}
						value={_('backToList')}
					/>
					<input
						onClick={() => onRemoveSignature(signature)}
						type="button"
                        className={`greyButton`}
                        disabled={this.isDisabledTheMakeDefault(signature) || !canBrokerCreateOrUpdate}
						value={_('removeSignature')}
                    />
                    {/** Removed and transfered to signatureList !canBrokerCreateOrUpdate &&
                        <input
                            onClick={() => onUpdateSignature(signature)}
                            type="button"
                            className={`greyButton`}
                            value={_('updateSignature')}
                        />
                    **/}
				</div>
                <form method="post" className={styles.signatureForm}>
                    <div className={cs(styles.formGroup,styles.inARow,styles.note)}>
                        {_("note")}: {
                            isDefaultField.value ?
                             <b>{_("thisIsDefaultSignature")}</b> :
                             _("thisIsNotDefaultSignature") }
                    </div>
                    <input type="hidden" {...isDefaultField}/>
                    <div className={cs(styles.formGroup, styles.subline)}>
                        <label htmlFor="name" className={styles.formLabel}>
                            {_("signatureName")}
                        </label>
                        <div className={cs(styles.inputHolder)}>
                            <input type="text" className={cs(styles.formInput,styles.textInput)}
                                {...nameField}
                                disabled={!canBrokerCreateOrUpdate}
                            />
                            {nameField.touched && nameField.error && <div className={styles.errorMessage}>
                                {nameField.error}
                            </div>}
                        </div>
                    </div>

                    {window.tinymce && this.renderBodyEditor()}

                    <div className={cs(styles.formGroup, styles.subline)}>
                        <label htmlFor="createdAt" className={styles.formLabel}>
                            {_("createdAt")}:
                        </label>
                        <span className={cs(styles.formInput, styles.onlyValue)}>
                            {signature.createdAt ? formatDate(signature.createdAt, 'eu') : '-'}
                        </span>
                    </div>
                    <div className={cs(styles.formGroup, styles.subline)}>
                        <label htmlFor="createdAt" className={styles.formLabel}>
                            {_("updatedAt")}:
                        </label>
                        <span className={cs(styles.formInput, styles.onlyValue)}>
                            {signature.updatedAt ? formatDate(signature.updatedAt, 'eu') : '-'}
                        </span>
                    </div>

                    <div className={styles.buttonsContainer}>
                            <div className={styles.cancelButton}
                                onClick={(e) => {
                                    e.preventDefault()
                                    onCloseSignature()
                                }}>{_("cancel")}
                            </div>
                            <button className={styles.buttonGreen}
                                disabled={this.isDisabledTheMakeDefault(signature) || !canBrokerCreateOrUpdate}
                                onClick={(e) => {
                                    e.preventDefault()
                                    if ( this.hasErrors() ) {
                                        return
                                    }
                                    onSetDefaultSignature(signature)
                                    this.updateFormValue({value: !isDefaultField.value}, isDefaultField)
                                }}>{isDefaultField.value ? _("markAsNotDefault") : _("markAsDefault")}
                            </button>
                            <button className={styles.buttonGreen}
                                disabled={!canBrokerCreateOrUpdate}
                                onClick={(e) => {
                                    e.preventDefault()
                                    if (this.hasErrors()) {
                                        this.updateFormValue({value: nameField.value, touched: true}, nameField)
                                        this.updateFormValue({value: contentField.value, touched: true}, contentField)
                                        return
                                    }
                                    onUpdateSignature({
                                        ...signature,
                                        name: nameField.value,
                                        content: contentField.value,
                                        isDefault: isDefaultField.value,
                                        brokerNumber: signature.brokerNumber || currentBrNr, // never update the owner broker!
                                    }, true)
                                    onCloseSignature()
                                }}>{_("save")}
                            </button>
                    </div>
                </form>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/office/signatureZoom.jsx